module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: !_vm.isCollapse ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 10
    },
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isProduct && _vm.apiBranch.length > 0),
      expression: "!isProduct && apiBranch.length > 0"
    }],
    staticClass: "api-branch",
    domProps: {
      "textContent": _vm._s(_vm.apiBranch)
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "tools",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.collapse($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  })])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 10
    }
  }, [_c('span', [_vm._v("产品 :")]), _vm._v(" "), _c('div', {
    staticClass: "product-select"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择App"
    },
    model: {
      value: (_vm.appId),
      callback: function($$v) {
        _vm.appId = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "appId"
    }
  }, _vm._l((_vm.appList), function(item) {
    return _c('el-option', {
      key: item.app_id,
      attrs: {
        "label": item.desc,
        "value": item.app_id
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.name),
      expression: "info.name"
    }],
    staticClass: "user-info"
  }, [_c('span', {
    staticClass: "nickname"
  }, [_vm._v(_vm._s(_vm.info.name))]), _vm._v(" "), _c('span', {
    staticClass: "logout",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("退出")])])])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "menu-box",
    class: _vm.isCollapse ? 'auto-width' : ''
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "router": "",
      "collapse": !_vm.isCollapse
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose
    }
  }, [_vm._l((_vm.menu), function(item, index) {
    return (!item.meta.hidden) ? [(item.children) ? _c('el-submenu', {
      key: index,
      attrs: {
        "index": item.path
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.meta.icon
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.meta.label))])]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.meta.hidden) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [_vm._v("\n                            " + _vm._s(child.meta.label) + "\n                        ")]) : _vm._e()
    })], 2) : _c('el-menu-item', {
      key: index,
      attrs: {
        "index": item.path,
        "disabled": ""
      }
    }, [_c('i', {
      class: item.meta.icon
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.meta.label))])])] : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('strong', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$route.meta.label))]), _vm._v(" "), _c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v("\n                            " + _vm._s(item.meta.label) + "\n                        ")])
  }))], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53e34a72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 595
// module chunks = 16